import phoneFormatter from 'phone-formatter';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import AppBar from 'material-ui/AppBar';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getDateString from '../../utils/getDateString';

const Link = styled.a`
	color: #75757c;
	padding-right: 40px;
	padding-left: 10px;
	text-transform: uppercase;
	font-size: 11px;
	font-weight: 600;
	letter-spacing: 1px;
	padding-top: 16px;
	padding-bottom: 16px;
	&:hover {
		color: #c655d6;
	}
`;

const Bar = styled(AppBar)`
	background-color: ${(props) =>
		props.color === 'white' ? '#fff !important' : ''};
	position: fixed;
	top: 0;
	margin-top: 0;
`;

const contactUsMobile = {
	backgroundColor: '#fff',
	textTransform: 'uppercase',
	borderRadius: '20px',
	color: '#75757c',
	letterSpacing: '1px',
	marginBottom: '12px',
	padding: '2px 20px'
};

const header = {
	backgroundColor: 'transparent',
	position: 'fixed',
	top: '0',
	marginTop: '0'
};

const headerLight = {
	backgroundColor: '#fff',
	top: '0',
	marginTop: '0'
};

const logoButton = {
	marginLeft: '0%',
	height: '100%',
	display: 'flex',
	alignItems: 'center'
};

const mt8 = {
	marginTop: '8px',
	marginBottom: '8px'
};

const logoLight = {
	color: 'black'
};

class Header extends Component {
	state = {
		width: window.innerWidth
	};

	componentDidMount() {
		window.addEventListener('resize', this.handleWindowSizeChange);
	}

	getMonthlyMessages = () => {
		const dateString = getDateString();
		if (this.props.auth.monthlyData) {
			const currentMonth = this.props.auth.monthlyData.filter((month) => {
				return month.date === dateString;
			});
			const messagesSent = currentMonth[0]
				? currentMonth[0].messagesSent
				: 0;
			return <span>{messagesSent} / 1000 SMS Sent This Month</span>;
		}
		return <span />;
	};

	getTwilioNumber = () => {
		if (this.props.auth && this.props.auth.twilioNumber) {
			const number = phoneFormatter.format(
				this.props.auth.twilioNumber,
				'(NNN) NNN - NNNN'
			);

			return <span>Your Chekkit # {number}</span>;
		}
	};

	getMessagesSent = (business, chosenMonth) => {
		// Selected Month must have the format 'Year Month'
		const month = chosenMonth.getMonthName();
		const year = chosenMonth.getFullYear();
		const selectedMonth = year + ' ' + month;

		// This is the Number of messages sent for the selected month.
		const messagesSent = business.monthlyData.filter(
			(data) => data.date === selectedMonth
		)[0]
			? business.monthlyData.filter(
					(data) => data.date === selectedMonth
			  )[0].messagesSent
			: 0;
		return messagesSent;
	};

	handleWindowSizeChange = () => {
		this.setState({ width: window.innerWidth });
	};

	hasCompleteAccount = () => {
		if (
			this.props.auth &&
			this.props.auth.phone &&
			this.props.auth.name &&
			this.props.auth.stripeId
		) {
			return 'complete';
		}
		return 'none';
	};

	renderHeader() {
		return (
			<div className="logo" style={logoButton}>
				<a
					className="waves-effect waves-light"
					style={{
						...logoLight,
						display: 'flex',
						alignItems: 'center',
						height: '100%'
					}}
					href={this.props.auth ? '/dashboard' : '/'}
				>
					<img
						style={{ width: '92px', display: 'block' }}
						src="/img/chekkit-logo.svg"
						alt="logo"
					/>
				</a>
			</div>
		);
	}

	renderContent() {
		const isMobile = this.state.width <= 640;
		switch (this.hasCompleteAccount()) {
			case 'none':
				if (isMobile) {
					return (
						<div>
							<a
								href="https://www.chekkit.io/contact-us"
								className="waves-effect waves-light"
								style={contactUsMobile}
							>
								<div>
									<strong>Contact Us</strong>
								</div>
							</a>

							<IconMenu
								{...this.props}
								iconButtonElement={
									<IconButton>
										<MoreVertIcon />
									</IconButton>
								}
								targetOrigin={{
									horizontal: 'right',
									vertical: 'top'
								}}
								anchorOrigin={{
									horizontal: 'right',
									vertical: 'top'
								}}
							>
								<MenuItem
									href="https://www.chekkit.io"
									primaryText="Home"
								/>
								<MenuItem
									href="https://www.chekkit.io/faq"
									primaryText="FAQs"
								/>
								<MenuItem href="/login" primaryText="Log In" />
							</IconMenu>
						</div>
					);
				}
				return (
					<div style={mt8}>
						<Link
							href="https://www.chekkit.io"
							className="link waves-effect waves-light"
						>
							<strong>Home</strong>
						</Link>
						<Link
							href="https://www.chekkit.io/contact-us"
							className="waves-effect waves-light"
						>
							<strong>Contact Us</strong>
						</Link>
						<Link
							href="/login"
							className="waves-effect waves-light"
						>
							<strong>Log In</strong>
						</Link>
					</div>
				);

			default:
				if (isMobile) {
					return (
						<div>
							<a
								href="/contact-us"
								className="waves-effect waves-light"
								style={contactUsMobile}
							>
								<div>
									<strong>Contact Us</strong>
								</div>
							</a>

							<IconMenu
								{...this.props}
								iconButtonElement={
									<IconButton>
										<MoreVertIcon />
									</IconButton>
								}
								targetOrigin={{
									horizontal: 'right',
									vertical: 'top'
								}}
								anchorOrigin={{
									horizontal: 'right',
									vertical: 'top'
								}}
							>
								<MenuItem
									href="https://www.chekkit.io"
									primaryText="Home"
								/>
								<MenuItem
									href="https://www.chekkit.io/faq"
									primaryText="FAQs"
								/>
								<MenuItem href="/login" primaryText="Log In" />
							</IconMenu>
						</div>
					);
				}
				return (
					<div style={mt8}>
						<Link
							href="https://www.chekkit.io"
							className="link waves-effect waves-light"
						>
							<strong>Home</strong>
						</Link>
						<Link
							href="https:///www.chekkit.io/contact-us"
							className="waves-effect waves-light"
						>
							<strong>Contact Us</strong>
						</Link>
						<Link
							href="/login"
							className="waves-effect waves-light"
						>
							<strong>Log In</strong>
						</Link>
					</div>
				);
		}
	}

	render() {
		return (
			<div>
				<MuiThemeProvider>
					<div style={{ height: 60 }}>
						<Bar
							id="app-bar"
							title={this.renderHeader()}
							zDepth={0}
							showMenuIconButton={false}
							color="white"
							style={
								this.props.barStyle === 'light'
									? headerLight
									: header
							}
							iconElementRight={this.renderContent()}
						/>
					</div>
				</MuiThemeProvider>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return { auth: state.auth };
}

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/index/Header.js